module.exports = __webpack_public_path__ + "static/media/malphos_1000ce.b18799dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/chile/climasense/picudo_pimiento/curativa/malphos_1000ce.png
// module id = 1444
// module chunks = 3